import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Typography } from "components/controls/widget";

export interface PageSubHeaderProps {
    titles: string[];
}

class PageSubHeader extends React.PureComponent<PageSubHeaderProps & WithStyles<typeof styles>> {

    render() {
        const { titles, classes } = this.props;
        const title = titles.join(" » ");
        return <div className={classes.root}>
            <Typography className={classes.typo} variant="subtitle2">{title}</Typography>
        </div>;
    }
}


export const styles = (theme: Theme) => createStyles({
    root: {
        padding: 2,
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        backgroundColor: theme.palette.primary.dark,
    },
    typo: {
        color: theme.palette.grey[200],
    }
});

export default withStyles(styles)(PageSubHeader);